import type { Color, GameState } from '@ccc/shared-types';

export function startClocks(state: GameState, now = Date.now(), ticking: Color = 'white'): void {
  state.clocks.lastTickAt = now;
  state.clocks.ticking = ticking;
}

export function applyClockTick(state: GameState, now = Date.now()): Color | null {
  if (state.status !== 'active' || !state.clocks.ticking) return null;
  const side = state.clocks.ticking;
  const elapsed = Math.max(0, now - state.clocks.lastTickAt);
  if (elapsed === 0) return null;
  const key = side === 'white' ? 'whiteMs' : 'blackMs';
  state.clocks[key] = Math.max(0, state.clocks[key] - elapsed);
  state.clocks.lastTickAt = now;
  if (state.clocks[key] > 0) return null;
  state.status = 'ended';
  state.endReason = 'timeout';
  state.winner = side === 'white' ? 'black' : 'white';
  state.clocks.ticking = null;
  return side;
}

export function finishMoveClock(state: GameState, mover: Color, now = Date.now()): void {
  if (state.status !== 'active') return;
  const key = mover === 'white' ? 'whiteMs' : 'blackMs';
  state.clocks[key] += state.incrementSeconds * 1000;
  state.clocks.lastTickAt = now;
  state.clocks.ticking = state.turn;
}

export function clockMsForDisplay(state: GameState, side: Color, now = Date.now()): number {
  const base = side === 'white' ? state.clocks.whiteMs : state.clocks.blackMs;
  if (state.status !== 'active' || state.clocks.ticking !== side) return Math.max(0, base);
  return Math.max(0, base - Math.max(0, now - state.clocks.lastTickAt));
}
